<template>
    <div class="forgot-password">

        <div class="card">
            <div class="card-header">
                <h5 class="card-title text-center">Forgot Password</h5>
                <hr>
            </div>
            <div class="card-body">
                <BasicTextInput label="Email" v-model="email" placeholder="Enter Email" class="mb-3"/>
                <button class="btn btn-primary btn-block" @click="submitPasswordReset">Submit</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { UserService } from '@/services';
    export default {
        name: "ForgotPassword",
        data: () => {
            return {
                email: ''
            }
        },
        methods: {
            submitPasswordReset(){
                UserService.triggerPasswordResetEmail({ email: this.email }).then(res => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'Password Reset Email Sent', type: 'success' });
                }).catch(err => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message, type: 'error' });
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .forgot-password {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .card {
            max-width: 500px;
            min-width: 350px;
        }
    }
</style>
